import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { Button } from 'lp-components'
import * as actions from '../actions'
import { IMAGE_PATH, PATH } from 'config'
const propTypes = {
  clearAllGiftState: PropTypes.func.isRequired,
}

function ConfirmGift({ clearAllGiftState }) {
  const confirmationText =
    'Virtual gift memberships will be emailed within 1 hour of purchase. Gift membership recipients will receive an activation code which they will use when joining or renewing.'

  useEffect(() => {
    return () => clearAllGiftState()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <section className="form-block-container confirmation">
      <div className="card card-medium">
        <header>
          <img alt="" src={IMAGE_PATH.GIFT_CONFIRMATION} className="confirmation-icon gift" />
        </header>
        <h2>Your Gift Has Set Sail</h2>
        <p>{confirmationText}</p>
        <p>
          <strong>
            Thank You for Gifting a Sea Tow Membership!
          </strong>
        </p>
        <Button
          className="button-primary"
          onClick={() => window.location.replace(PATH.SEATOW)}
        >
          Return to Website
        </Button>
      </div>
    </section>
  )
}

ConfirmGift.propTypes = propTypes

function mapStateToProps() {
  return {}
}

const mapDispatchToProps = {
  clearAllGiftState: actions.clearAllGiftState,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ConfirmGift
)
